export const CSS_VAR_PREFIX = 'bee'